import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCamera, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../hooks/useFetch";
import Swal from "sweetalert2";

// https://dev.to/bytebodger/constructors-in-functional-components-with-hooks-280m
// https://reactjs.org/docs/hooks-state.html
// https://beta.reactjs.org/reference/react/useRef
// https://ui.dev/react-router-pass-props-to-link

export default function Usuario() {
    const navigate = useNavigate();
    const { get, post, put } = useFetch();
    const defaultState = {
        acao: "Visualizar",
        imagemAlterada: false,
        usuario: { id_usuario: "", email: "", senha: "", confirmar_senha: "", nome_usuario: "", status_usuario: "", funcao: "", nome_pessoa: "", foto: [], base64: ""}
    }
    /* objeto recebido do state={} do <Link> da página anterior
    ** https://v5.reactrouter.com/web/api/location  https://v5.reactrouter.com/web/api/Hooks/uselocation */
    let location = useLocation();

    // https://v5.reactrouter.com/web/example/url-params
    let { id } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            let usuario = defaultState.usuario;
            if (id === "criar") {
                setState({ ...state, acao: "Criar" });
            }
            else {
                usuario = await buscarUsuario(id);
                setState({ 
                    ...state, 
                    usuario: usuario,
                });
            }
        }
        fetchData();
    }, [id])

    /* https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    ** define o state inicial do componente, o useState retorna um array com 2 elementos, 
    ** objeto state e função setState pra atualizar o objeto state */
    const [state, setState] = useState(() => {
        // se a página anterior passou um state, retorna ele
        if (location.state) {
            if (location.state.acao) {
                defaultState.acao = location.state.acao;
            }
        }
        // senão, retorna um objeto vazio
        return defaultState;
    });

    function changeUsuario(event) {
        let name = event.target.name; // name do campo que disparou o evento
        let value = event.target.value; // value do campo    
        let target = event.target;

        if (target.type === 'select-one') {
            value = target.options[target.selectedIndex].value;
        }

        // ex: se o campo com name Nome for alterado, atualiza o objeto state com o novo valor do campo Nome
        // { Nome: "novo valor do campo Nome" }
        setState(prevState => ({
            ...prevState,
            usuario: {
                ...prevState.usuario,
                [name]: value
            }
        }));
    }

    async function buscarUsuario(id) {
        try {
            let response = await get("/usuario/" + id);
            if (response.status === 200) {
                let dados = response.result.data;
                if (dados === null)
                    return defaultState.usuario;
                return dados;
            } 
        } catch (error) {
            console.error("Erro no buscarUsuario():", error);
            return defaultState.usuario;
        }
    }

    async function salvarUsuario() {
        let method = state.acao === "Criar" ? post : put;
        try {
            let formData = new FormData();
            formData.append('id_usuario', state.usuario.id_usuario);
            formData.append('email', state.usuario.email);
            formData.append('senha', state.usuario.senha);
            formData.append('nome_usuario', state.usuario.nome_usuario);
            formData.append('status_usuario', state.usuario.status_usuario);
            formData.append('funcao', state.usuario.funcao);
            formData.append('nome_pessoa', state.usuario.nome_pessoa);
            formData.append('imagemAlterada', state.imagemAlterada);
            
            if(state.imagemAlterada === true) {
                formData.append('foto', new File([state.usuario.foto], 'image.png'));
            }

            let response = await method(`/usuario/${state.usuario.id_usuario}`, formData, null, 'multipart/form-data');
            if (response.status === 200 || response.status === 201) {
                // redireciona para a página /usuarios              
                navigate("/admin/usuarios");
            } else {
                Swal.fire({
                    title: "Não foi possível salvar o usuario",
                    text: "Erro ao salvar usuario",
                    icon: "error",
                })
            }
        } catch (error) {
            console.error("Erro no salvarUsuario():", error);
        }
    }

    const [imageUrl, setImageUrl] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setState({
            ...state,
            imagemAlterada: true,
            usuario: {
              ...state.usuario,
              foto: file
            }
        });

        const objectURL = URL.createObjectURL(file);
        setImageUrl(objectURL);
    };

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/usuarios" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar aos Usuários
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4">
                    <div className="section-title-modern mb-4">
                        <div className="title-accent"></div>
                        <h2 className="admin-title">{state.acao === "EdicaoPropria" ? "Minha Conta" : `${state.acao} Usuário`}</h2>
                    </div>

                    <div className="row">
                        {/* Coluna da Foto */}
                        <div className="col-lg-3 text-center mb-4">
                            <div className="profile-photo-wrapper mb-3">
                                {state.imagemAlterada ? (
                                    // 1. Mostra o preview da imagem que acabou de ser selecionada
                                    <img src={imageUrl} alt="preview" className="profile-img-preview" />
                                ) : state.usuario.base64 ? (
                                    // 2. Mostra a foto vinda do banco de dados
                                    <img src={`data:image/jpeg;base64,${state.usuario.base64}`} alt="foto" className="profile-img-preview" />
                                ) : (
                                    // 3. Mostra o ícone padrão caso não haja foto
                                    <div className="profile-placeholder">
                                        <FontAwesomeIcon icon={faUserCircle} />
                                    </div>
                                )}
                                
                                {/* Botão de upload (apenas se não estiver em modo Visualizar) */}
                                {state.acao !== "Visualizar" && (
                                    <label className="photo-upload-btn" title="Alterar foto">
                                        <FontAwesomeIcon icon={faCamera} />
                                        <input 
                                            type="file" 
                                            hidden 
                                            accept="image/*" 
                                            onChange={handleFileUpload} 
                                        />
                                    </label>
                                )}
                            </div>
                            <div className="text-muted small fw-bold text-uppercase" style={{ letterSpacing: '1px' }}>
                                Foto de Perfil
                            </div>
                        </div>

                        {/* Coluna dos Dados */}
                        <div className="col-lg-9">
                            <div className="row g-3">
                                <Form.Group className="col-md-12">
                                    <Form.Label className="label-admin">Nome Completo</Form.Label>
                                    <Form.Control className="input-moderno" name="nome_pessoa" value={state.usuario.nome_pessoa} onChange={changeUsuario} disabled={state.acao === "Visualizar"} />
                                </Form.Group>

                                <Form.Group className="col-md-6">
                                    <Form.Label className="label-admin">E-mail</Form.Label>
                                    <Form.Control className="input-moderno" name="email" value={state.usuario.email} onChange={changeUsuario} disabled={state.acao === "Visualizar"} />
                                </Form.Group>

                                <Form.Group className="col-md-6">
                                    <Form.Label className="label-admin">Nome de Usuário (Login)</Form.Label>
                                    <Form.Control className="input-moderno" name="nome_usuario" value={state.usuario.nome_usuario} onChange={changeUsuario} disabled={state.acao === "Visualizar"} />
                                </Form.Group>

                                <Form.Group className="col-md-6">
                                    <Form.Label className="label-admin">Função no Sistema</Form.Label>
                                    <Form.Select className="input-moderno" name="funcao" value={state.usuario.funcao} onChange={changeUsuario} disabled={state.acao === "Visualizar"}>
                                        <option value="">Selecionar...</option>
                                        <option value="Desenvolvedor">Desenvolvedor</option>
                                        <option value="Administrador">Administrador</option>
                                        <option value="Funcionario">Funcionário</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="col-md-6">
                                    <Form.Label className="label-admin">Status da Conta</Form.Label>
                                    <div className="d-flex gap-3 mt-2">
                                        <Form.Check type="radio" label="Ativo" name="status_usuario" value="Ativo" checked={state.usuario.status_usuario === "Ativo"} onChange={changeUsuario} disabled={state.acao === "Visualizar"} />
                                        <Form.Check type="radio" label="Inativo" name="status_usuario" value="Inativo" checked={state.usuario.status_usuario === "Inativo"} onChange={changeUsuario} disabled={state.acao === "Visualizar"} />
                                    </div>
                                </Form.Group>

                                {state.acao === "Criar" && (
                                    <>
                                        <Form.Group className="col-md-6">
                                            <Form.Label className="label-admin">Senha</Form.Label>
                                            <Form.Control type="password" className="input-moderno" name="senha" onChange={changeUsuario} />
                                        </Form.Group>
                                        <Form.Group className="col-md-6">
                                            <Form.Label className="label-admin">Confirmar Senha</Form.Label>
                                            <Form.Control type="password" className="input-moderno" name="confirmar_senha" onChange={changeUsuario} />
                                        </Form.Group>
                                    </>
                                )}
                            </div>

                            {state.acao !== "Visualizar" && (
                                <div className="d-flex justify-content-end mt-5 pt-3 border-top gap-2">
                                    {state.acao === "EdicaoPropria" && (
                                        <Button variant="outline-secondary" className="rounded-pill px-4" onClick={() => navigate("/admin/senhas/")}>Alterar Senha</Button>
                                    )}
                                    <Button className="btn-apply-filters px-5" onClick={salvarUsuario}>Salvar Alterações</Button>
                                </div>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}